/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionstellassistant3Inputs */

const en_openquestionstellassistant3 = /** @type {(inputs: Openquestionstellassistant3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell the assistant`)
};

const pt_openquestionstellassistant3 = /** @type {(inputs: Openquestionstellassistant3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falar com o assistente`)
};

/**
* | output |
* | --- |
* | "Tell the assistant" |
*
* @param {Openquestionstellassistant3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionstellassistant3 = /** @type {((inputs?: Openquestionstellassistant3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionstellassistant3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionstellassistant3(inputs)
	return pt_openquestionstellassistant3(inputs)
});
export { openquestionstellassistant3 as "openQuestionsTellAssistant" }